import React, { useEffect, useState } from 'react'
import { Form } from 'formik'
import { FormColumn, FormRow, TitleBar } from 'components/Shared/CrudComponents'
import { useTranslation } from 'react-i18next'
import { createValidationSchema } from './form'
import { FormikForm } from 'components/Shared/FormikForm'
import { handleGroupMembersChange } from 'components/UserGroups/UserGroupsForm/utils'
import { ORDER_APPROVE_FOR_FULFILLMENT, useAuth } from 'context/auth'
import SelectPrivilegesFormField from './SelectPrivilegesFormField/SelectPrivilegesFormField'
import { Label } from 'components/Shared/Label'
import { IndependentFieldComponent } from 'components/Shared/IndependentFieldComponent'
import { SelectUsersField } from 'components/Shared/SelectUsersField'

export default function UserGroupsForm ({
  initialValues,
  initialMembers,
  onSubmit,
  title,
  isCreateForm,
  requiredPrivileges
}) {
  const [members, setMembers] = useState(initialMembers)
  const { hasAnyPrivileges } = useAuth()

  useEffect(() => setMembers(initialMembers), [initialMembers])

  const { t } = useTranslation()

  const handleMembersChange = (groupId) => {
    const initialIds = isCreateForm ? [] : initialMembers.map(member => member.userId)
    const selectedIds = members.map(member => member.userId)
    return handleGroupMembersChange(groupId, initialIds, selectedIds)
  }

  const mapValuesBeforeSubmit = (groupValues) => {
    const hasOrderApprovePrivilege = groupValues.privileges.includes(ORDER_APPROVE_FOR_FULFILLMENT)
    return {
      name: groupValues.name,
      privileges: groupValues.privileges.map(p => ({ privilege: p })),
      orderApproveProperties: hasOrderApprovePrivilege ? groupValues.orderApproveProperties : null
    }
  }

  const hasWritePrivilege = hasAnyPrivileges(requiredPrivileges)
  return (
    <>
      <FormikForm
        initialValues={initialValues}
        validationSchema={createValidationSchema()}
        validateOnChange={false}
        validateOnBlur
        enableReinitialize
        preventNavigation={false}
        onSubmit={groupValues => onSubmit(mapValuesBeforeSubmit(groupValues), handleMembersChange)}>
        <Form>
          <TitleBar
            buttonLabel={t('userGroups.form.submit')}
            title={title}
            isButtonDisabled={!hasWritePrivilege}/>
          <FormRow>
            <FormColumn className={'w-100'} disabled={!hasWritePrivilege}>
              <Label text={'userGroups.form.name'}/>
              <IndependentFieldComponent
                fieldName="name"/>
              <Label text={'userGroups.form.members'}/>
              <SelectUsersField
                members={members}
                onMembersChanged={setMembers}
              />
              <Label text={'userGroups.form.privileges'}/>
              <SelectPrivilegesFormField/>
            </FormColumn>
          </FormRow>
        </Form>
      </FormikForm>
    </>
  )
}
